import Vue from 'vue'
import App from './App.vue'
import i18n from './components/i18n.js';
import VueRouter from 'vue-router'

import VerificationPage from "./components/VerificationPage.vue";
//import HomePage from './components/HomePage.vue'  // 导入 HomePage
// import HomePage3 from "./components/HomePage3";

Vue.use(VueRouter)

// 定义路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    component: VerificationPage  // 根路径显示 HomePage
  },
  // {
    // path: '/verfication',
    // name: 'VerificationPage',
    // component: VerificationPage
  // },
  // {
  // path: '/HomePage3',
  // name: 'HomePage3',
  // component: HomePage3
  // }
  
]
// 创建路由实例
const router = new VueRouter({
  mode: 'history', // 使用 history 模式，去除 URL 中的 #
  routes
})

// Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
